export const orderBasedInitial = {
  orderValue: "",
  reward: 0,
};
export const visitBasedInitial = {
  rewardPerVisit: 0,
};
export const feedbackBasedInitial = {
  rewardPerFeedback: 0,
};

export const addNewLoyalty = async (loyaltyObject, setLoyalty) => {
  const userToken = localStorage.getItem("user");
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/loyalty/addloyalty",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(loyaltyObject),
      }
    );
    const result = await response.json();
    setLoyalty(result);
  } catch (err) {
    console.log(err);
  }
};
export const getLoyalty = async (setLoyalty) => {
  const userToken = localStorage.getItem("user");
  const hotelID = localStorage.getItem("hotelID");
  const requestObject = {
    hotelID: hotelID,
  };
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/loyalty/getloyalty",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
    setLoyalty(result);
  } catch (err) {
    console.log(err);
  }
};

export const deleteLoyalty = async (setLoyalty) => {
  const userToken = localStorage.getItem("user");
  const hotelID = localStorage.getItem("hotelID");
  const requestObject = {
    hotelID: hotelID,
  };
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/loyalty/deleteloyalty",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
    setLoyalty(result);
  } catch (err) {
    console.log(err);
  }
};
